var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_61_info-circle",
    "data-name": "61 info-circle",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55639",
    "data-name": "Path 55639",
    d: "M26,3A23,23,0,1,0,49,26,23,23,0,0,0,26,3Zm5.308,33.615H20.692V33.077h3.538V22.462H22.709V18.923H26a1.769,1.769,0,0,1,1.769,1.769V33.077h3.538ZM25.469,11.032a2.212,2.212,0,0,1,2.3,2.212v.885a2.212,2.212,0,1,1-4.423,0v-.885a2.212,2.212,0,0,1,2.123-2.212Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderGeneral);
export default __webpack_public_path__ + "static/media/profile-builder-general.397f506835153dca6f5d8b0e49c17b65.svg";
export { ForwardRef as ReactComponent };